import React from 'react';

const SVG = ({ style = {}, fill = '#000', width = 100, className = '', viewBox = '0 0 48 48' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    viewBox={viewBox}
    className={`svg-icon ${className || ''}`}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h48v48H0z" />
      <g transform="translate(5 7)">
        <path
          fill="#FF7C97"
          d="M28.692 9.523c-.892 0-1.74.103-2.54.308a6.137 6.137 0 0 0-.036-.71c-.487-4.54-5.994-8.34-6.229-8.5L18.977 0l-.91.62c-.233.16-5.717 3.945-6.208 8.494-.026.25-.039.497-.036.741a10.227 10.227 0 0 0-2.585-.318c-4.325 0-8.145 2.494-8.305 2.6L0 12.754l.374 1.002c.11.292 2.393 6.244 7.456 7.9a7.082 7.082 0 0 0-.486.714c-2.38 3.98-.516 9.747-.435 9.99l.327.98 1.105.025.132.002c3.219 0 8.042-.957 10.492-4.074.976 1.263 2.414 2.266 4.286 2.975 2.696 1.02 5.45 1.099 6.231 1.099l.133-.002 1.073-.025.344-.939c.927-2.536 1.514-7.102-.87-10.407 5.062-1.439 7.327-7.967 7.432-8.278l.332-.981-.903-.597c-.161-.107-4.004-2.615-8.331-2.615z"
        />
        />
        <path
          fill="#FFC120"
          d="M19.082 21.415c-1.571 0-2.85-1.227-2.85-2.735 0-1.509 1.279-2.735 2.85-2.735 1.572 0 2.852 1.226 2.852 2.735 0 1.507-1.28 2.735-2.852 2.735z"
        />
        />
        <ellipse cx="13.781" cy="16.009" fill="#FFC120" rx="1.517" ry="1.455" />
        <ellipse cx="19.238" cy="11.816" fill="#FFC120" rx="1.517" ry="1.455" />
        <ellipse cx="15.529" cy="23.147" fill="#FFC120" rx="1.517" ry="1.455" />
        <ellipse cx="22.749" cy="23.147" fill="#FFC120" rx="1.517" ry="1.455" />
        <ellipse cx="24.134" cy="16.009" fill="#FFC120" rx="1.517" ry="1.455" />
      </g>
    </g>
  </svg>
);

export default SVG;
